import React, { PureComponent } from 'react';
import { Sidebar } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import AddArt from '../add_art';
import AddOther from '../add_other';
import GuidesConfig from '../guides_config';
import Info from '../info';
import Export from '../export';
import WorkDetails from '../work_details';
import MoreLikeThis from '../more_like_this';
import CustomPreviewPanel from '../custom_preview_panel';
import Hanging from '../hanging';
import Constants from '../../config/const';
import * as classes from './classes.module.scss';

const PANEL_DIRECTION_BY_KIND = {
  [Constants.panelKinds.works]:  'left',
  [Constants.panelKinds.other]:  'left',
  [Constants.panelKinds.grids]:  'left',
  [Constants.panelKinds.export]: 'left',
  [Constants.panelKinds.info]:   'right',
  [Constants.panelKinds.details]:'left',
  [Constants.panelKinds.moreLikeThis]: 'left',
  [Constants.panelKinds.customPreview]: 'right',
  [Constants.panelKinds.hanging]: 'right'
};

const PANEL_CONTENT_BY_KIND = {
  [Constants.panelKinds.works]: AddArt,
  [Constants.panelKinds.other]: AddOther,
  [Constants.panelKinds.grids]: GuidesConfig,
  [Constants.panelKinds.export]: Export,
  [Constants.panelKinds.info]: Info,
  [Constants.panelKinds.details]: WorkDetails,
  [Constants.panelKinds.moreLikeThis]: MoreLikeThis,
  [Constants.panelKinds.customPreview]: CustomPreviewPanel,
  [Constants.panelKinds.hanging]: Hanging
};

const PANEL_WIDTH_BY_KIND = {
  [Constants.panelKinds.works]: 'very wide',
  [Constants.panelKinds.other]: 'very wide',
  [Constants.panelKinds.grids]: 'thin',
  [Constants.panelKinds.info]: 'thin',
  [Constants.panelKinds.export]: 'very wide',
  [Constants.panelKinds.details]: 'wide',
  [Constants.panelKinds.moreLikeThis]: 'very wide',
  [Constants.panelKinds.customPreview]: 'thin',
  [Constants.panelKinds.hanging]: 'very wide'
};

const contentByKind = (doRender, C, options) => {
  if (!C || !doRender) { return null; }
  return <C { ...options } />;
};

const panelContentByKind = (doRender, kind, options) => contentByKind(
  doRender || kind === Constants.panelKinds.works,
  PANEL_CONTENT_BY_KIND[kind],
  options
  // doRender, PANEL_CONTENT_BY_KIND[kind], options
);

export default class Panels extends PureComponent {
  static propTypes = {
    kind: PropTypes.string,
    options: PropTypes.object,
    closePanel: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      [Constants.panelKinds.works]: false,
      [Constants.panelKinds.other]: false,
      [Constants.panelKinds.grids]: false,
      [Constants.panelKinds.export]: false,
      [Constants.panelKinds.info]: false,
      [Constants.panelKinds.details]: false,
      [Constants.panelKinds.moreLikeThis]: false,
      [Constants.panelKinds.customPreview]: false,
      [Constants.panelKinds.hanging]: false
    };
  }

  onShow = (kind) => this.setState({ [kind]: true });

  onHidden = (kind) => this.setState({ [kind]: false });

  onHide = (panelKind) => {
    if (panelKind === Constants.panelKinds.details || panelKind === Constants.panelKinds.info) {
      return;
    }
    const { closePanel } = this.props;
    closePanel(panelKind);
  }

  render() {
    const { kind, options } = this.props;

    return (
      <>
        {
          Object.keys(PANEL_CONTENT_BY_KIND).map((panelKind) => (
            <Sidebar
              animation="overlay"
              icon="labeled"
              visible={ panelKind === kind }
              key={ panelKind }
              className={ classes.panelDefault }
              onVisible={ () => this.onShow(panelKind) }
              onHidden={ () => this.onHidden(panelKind) }
              onHide={ () => this.onHide(panelKind) }
              width={ PANEL_WIDTH_BY_KIND[panelKind] }
              direction={ PANEL_DIRECTION_BY_KIND[panelKind] }
            >
              {
                panelContentByKind(
                  // eslint-disable-next-line react/destructuring-assignment
                  this.state[panelKind],
                  panelKind,
                  panelKind === kind ? (options || {}) : {}
                )
              }
            </Sidebar>
          ))
        }
      </>
    );
  }
}
